import React from 'react';

import { useMomentumBarSlotVisible } from '../../hooks/useMomentumBarSlotVisible';
import { MomentumBar } from '../MomentumBar';
import { MomentumBarScrollPastTracker } from '../MomentumBarScrollPastTracker';

type Props = Readonly<{
	petitionId: string;
}>;

export const MomentumBarExperimentContent: React.FC<Props> = ({ petitionId }) => {
	const momentumBarSlotVisible = useMomentumBarSlotVisible();

	return (
		<>
			<MomentumBar />
			{momentumBarSlotVisible && <MomentumBarScrollPastTracker petitionId={petitionId} />}
		</>
	);
};
